import {registerReducer} from './reducer';
import Immutable from 'immutable';

const EMPTY_LIST = Immutable.List([]);
const pendingRequestPath = ['modal', 'pendingRequests'];
const messageBoxPath = ['modal', 'messageBoxes'];

registerReducer('pendingRequests.showPendingRequest', (state, action) => {
	const {handle, message} = action.request;
	return state.setIn(
		pendingRequestPath,
		(state.getIn(pendingRequestPath) || EMPTY_LIST).push(Immutable.fromJS({
			handle,
			message
		}))
	);
});

registerReducer('pendingRequests.setMessage', (state, action) => {
	const handle = action.handle;
	const requests = state.getIn(pendingRequestPath);
	const index = requests.findIndex(request => request.get('handle') === handle);
	if (index < 0) {
		return state;
	} else {
		return state.setIn(pendingRequestPath, requests.setIn([index, 'message'], action.message));
	}
});


registerReducer('pendingRequests.hidePendingRequest', (state, action) => {
	const handle = action.handle;
	const requests = state.getIn(pendingRequestPath);
	const index = requests.findIndex(request => request.get('handle') === handle);
	if (index < 0) {
		return state;
	} else {
		return state.setIn(pendingRequestPath, requests.delete(index));
	}
});

registerReducer('messageBox.showMessageBox', (state, action) => {
	const {handle, message, options, callback} = action.request;
	return state.setIn(
		messageBoxPath,
		(state.getIn(messageBoxPath) || EMPTY_LIST).push(Immutable.fromJS({
			handle,
			message,
			options,
			callback
		}))
	);
});

registerReducer('messageBox.hideMessageBox', (state, action) => {
	const handle = action.handle;
	const requests = state.getIn(messageBoxPath);
	const index = requests.findIndex(request => request.get('handle') === handle);
	if (index < 0) {
		return state;
	} else {
		return state.setIn(messageBoxPath, requests.delete(index));
	}
});